import { Link } from 'react-router-dom';

const featureImages: Record<string, string> = {
  'Smart Templates': 'https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20colorful%20template%20documents%20and%20folder%20tabs%20on%20warm%20cream%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition%2C%20no%20text%2C%20structured%20layout%2C%20modern%20office%20aesthetic&width=600&height=400&seq=feature-templates-v3&orientation=landscape',
  'Data Organization': 'https://readdy.ai/api/search-image?query=Abstract%20data%20organization%20visual%20with%20neatly%20arranged%20colorful%20blocks%20and%20categories%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20minimalist%20geometric%20composition%2C%20no%20text%2C%20clean%20systematic%20layout%2C%20modern%20tech%20aesthetic&width=600&height=400&seq=feature-data-v3&orientation=landscape',
  'Business Analytics': 'https://readdy.ai/api/search-image?query=Abstract%20business%20analytics%20dashboard%20with%20soft%20colorful%20charts%20and%20graphs%20on%20warm%20cream%20background%2C%20gentle%20natural%20lighting%2C%20editorial%20photography%2C%20minimalist%20data%20visualization%2C%20no%20text%2C%20clean%20modern%20composition%2C%20professional%20aesthetic&width=600&height=400&seq=feature-analytics-v3&orientation=landscape',
  'Productivity Boost': 'https://readdy.ai/api/search-image?query=Abstract%20productivity%20concept%20with%20rising%20arrow%20and%20efficiency%20symbols%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20minimalist%20motivational%20composition%2C%20no%20text%2C%20clean%20uplifting%20layout%2C%20modern%20growth%20aesthetic&width=600&height=400&seq=feature-productivity-v3&orientation=landscape',
};

const features = [
  {
    icon: 'ri-file-text-line',
    title: 'Smart Templates',
    description: 'Ready-to-use spreadsheet structures designed for diverse business needs, from inventory tracking to financial analysis.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Data Organization',
    description: 'Manage complex information with intuitive workflows that keep your data structured, accessible, and easy to interpret.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Business Analytics',
    description: 'Transform raw spreadsheet data into actionable insights with powerful visualization and reporting capabilities.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Productivity Boost',
    description: 'Dramatically reduce repetitive manual tasks through intelligent automation and streamlined data processing.',
  },
];

export default function ContentSection() {
  return (
    <>
      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              What Is VigorBuy Spreadsheet?
            </h2>
            <div className="w-16 h-1 bg-primary-400 rounded-full mx-auto mb-6"></div>
            <p className="text-foreground-600 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
              <strong className="text-foreground-900">VigorBuy Spreadsheet</strong> is a modern data management framework that brings structure and clarity to your business operations. Whether you manage ecommerce inventory, track financial performance, organize marketing campaigns, or coordinate project workflows, this spreadsheet solution equips you with the tools to handle data efficiently and make informed decisions.
            </p>
            <p className="text-foreground-600 text-base md:text-lg max-w-3xl mx-auto leading-relaxed mt-4">
              Built with versatility in mind, VigorBuy Spreadsheet adapts to industries ranging from retail and logistics to finance and education. Its template-driven approach ensures you spend less time formatting and more time analyzing — making it an essential resource for professionals who value accuracy and productivity.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              Why Choose VigorBuy Spreadsheet?
            </h2>
            <div className="w-16 h-1 bg-accent-400 rounded-full mx-auto mb-6"></div>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
              Thousands of professionals trust our spreadsheet resources to simplify their daily workflows
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((f) => (
              <div key={f.title} className="group flex flex-col rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:shadow-md transition-all duration-300 overflow-hidden">
                <div className="relative w-full h-40 overflow-hidden">
                  <img
                    src={featureImages[f.title]}
                    alt={f.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent"></div>
                </div>
                <div className="p-5 md:p-6">
                  <div className="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center mb-3 group-hover:bg-accent-100 transition-colors duration-300">
                    <i className={`${f.icon} text-xl text-accent-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{f.title}</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">{f.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              VigorBuy Spreadsheet vs Alternatives
            </h2>
            <div className="w-16 h-1 bg-primary-400 rounded-full mx-auto mb-6"></div>
          </div>

          <div className="overflow-x-auto rounded-2xl border border-background-200/70 bg-background-50">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100">
                  <th className="text-left px-5 py-4 font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                  <th className="text-center px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">VigorBuy Spreadsheet</th>
                  <th className="text-center px-5 py-4 font-semibold text-foreground-700 whitespace-nowrap">Excel</th>
                  <th className="text-center px-5 py-4 font-semibold text-foreground-700 whitespace-nowrap">Google Sheets</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Business Templates', v: 'Excellent', e: 'Medium', g: 'Medium' },
                  { feature: 'Collaboration', v: 'Excellent', e: 'Medium', g: 'High' },
                  { feature: 'Automation', v: 'Advanced', e: 'Advanced', g: 'Medium' },
                  { feature: 'Learning Curve', v: 'Easy', e: 'Medium', g: 'Easy' },
                  { feature: 'Business Integration', v: 'Excellent', e: 'Good', g: 'Good' },
                  { feature: 'Custom Workflows', v: 'Excellent', e: 'Good', g: 'Medium' },
                ].map((row, i) => (
                  <tr key={row.feature} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                    <td className="px-5 py-3.5 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                    <td className="px-5 py-3.5 text-center">
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold">
                        <i className="ri-check-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                        {row.v}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-center text-foreground-600">{row.e}</td>
                    <td className="px-5 py-3.5 text-center text-foreground-600">{row.g}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-10">
            <Link
              to="/vigorbuy-spreadsheet-comparison"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-white text-sm font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Full Comparison Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}